import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  comment: Yup.string().required('Campul este obligatoriu.'),
  file: Yup.mixed().required('Trebuie să încărcați o imagine.')
})
